// Safe gtag event helper. The base Google tag (GT-WB5FLSPC) is loaded in index.html
// and routes to GA4 (G-311RKM9SF) and Google Ads (AW-17917962369) via Google account config.
export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}
